import { type FC } from "react";

import styled from "@emotion/styled";
import { Colors } from "@snapchat/snap-design-system";
import { AnalyticsIcon } from "@snapchat/snap-design-system-icons";

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    width: 100%;
    height: 104px;
`;

const MainText = styled.span`
    margin-top: 8px;
    padding-bottom: 4px;

    font-size: 12px;
    font-weight: 500;
    line-height: 16px;
    color: ${Colors.Black.V200};
`;

const Text = styled.span`
    font-size: 12px;
    font-weight: normal;
    line-height: 16px;
    color: ${Colors.Black.V200};
    text-align: center;
`;

interface StatsEmptyStateProps {
    title: string;
    description: string;
}

export const StatsEmptyState: FC<StatsEmptyStateProps> = ({ description, title }) => (
    <Container>
        <AnalyticsIcon size={24} />
        <MainText>{title}</MainText>
        <Text>{description}</Text>
    </Container>
);
